export default function DetailsRenderer({ type, details }) {
  
  if (!details || Object.keys(details).length === 0) {
    return <p>No extra details available.</p>;
  }

  switch (type) {
    case "blog":
      return details.link && details.link.trim() !== "" ? (
        <p>
          <a href={details.link} target="_blank" rel="noreferrer" className="btn btn-primary py-2 px-4">
            View the Video
          </a>
        </p>
      ) : null;

    case "event":
    case "workshop":
    case "report":
    case "livinglab":
      return details.report && details.report.trim() !== "" ? (
        <p>
          <a
            href={`https://node.lcwe-lb.com/uploads/reports/${details.report}`}
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary py-2 px-4"
          >
            View Full Report
          </a>
        </p>
      ) : null;

    case "publication":
      return (
        <div>
            <br></br>
            <h4>Citation: </h4>
            <p>{details.citation}</p>
            <p><h4>DOI: </h4>
            {details.doi && (
            <a href={details.doi} target="_blank" rel="noreferrer">
              {details.doi}
            </a>
            )}</p>
            <h4 className="mb-4">Keywords: </h4>
            <p>{details.keyword}</p>
        </div>
      );

    case "training":
      return (
        <>
        <h4 className="mb-4">Objectives: </h4>
        <p>{details.objective}</p>
        <h4 className="mb-4">Format: </h4>
        <p>{details.format}</p>
        </>
      );

    case "project":
      return (
        <div>
          <p><strong>End Date:</strong> {details.end_date}</p> <br/>
          <b>Project Overview:</b> <p>{details.overview}</p>  <br/>
          <b>Funding:</b> <p>{details.funding}</p> <br/>
          <b>Focus Region:</b> <p>{details.location}</p> <br/>
          <b>Partner:</b> <p>{details.partner}</p> <br/>
          <b>Mission:</b> <p>{details.mission}</p> <br/>
          <b>Vision:</b> <p>{details.vision}</p> <br/>
          <b>Goal:</b> <p>{details.goal}</p> <br/>
          <b>Project Objective: </b>
          {details.objective && details.objective.includes("/")
            ? (
              <ul>
                {details.objective.split("/").map((obj, idx) => (
                  <li key={idx}>{obj.trim()}</li>
                ))}
              </ul>
            )
            : (
              <p>{details.objective}</p>
            )
          }<br/>
          <b>Key Activity: </b>
          {details.activity && details.activity.includes("/")
            ? (
              <ul>
                {details.activity.split("/").map((obj, idx) => (
                  <li key={idx}>{obj.trim()}</li>
                ))}
              </ul>
            )
            : (
              <p>{details.activity}</p>
            )
          }<br/>
          <b>Expected Impact: </b>
          {details.impact && details.impact.includes("/")
            ? (
              <ul>
                {details.impact.split("/").map((obj, idx) => (
                  <li key={idx}>{obj.trim()}</li>
                ))}
              </ul>
            )
            : (
              <p>{details.impact}</p>
            )
          }<br/>
          <b>Role of LCWE: </b>
          {details.role && details.role.includes("/")
            ? (
              <ul>
                {details.role.split("/").map((obj, idx) => (
                  <li key={idx}>{obj.trim()}</li>
                ))}
              </ul>
            )
            : (
              <p>{details.role}</p>
            )
          }
        </div>
      );

    default:
      return null;
  }
}
